import { sva } from '@allenai/varnish-panda-runtime/css';

import type { RecipeVariantProps } from '@allenai/varnish-panda-runtime/types';

const tabsRecipe = sva({
    slots: ['root', 'tabList', 'tab', 'tabPanel'],
    base: {
        root: {
            background: 'background.opacity-100',
            color: 'text',
            display: 'grid',
            gap: '[8px]',
        },
        tabList: {
            display: 'flex',
            gap: '[8px]',
        },
        tab: {
            padding: '[8px 16px]',
            fontSize: '[14px]',
            gap: '[8px]',
            outlineWidth: '0', // no focus outline

            _hover: {
                _notDisabled: {
                    color: 'links',
                    cursor: 'pointer',
                },
            },
            _selected: {
                _notDisabled: {
                    color: 'links',
                },
            },
            _disabled: {
                color: 'text.disabled',
                cursor: 'not-allowed',
            },
        },
        tabPanel: {},
    },
    variants: {
        orientation: {
            horizontal: {
                root: {
                    gridTemplateRows: 'auto 1fr',
                },
                tabList: {
                    flexDirection: 'row',
                },
                tab: {
                    paddingBottom: '[5px]', // to account for border
                    borderBottom: '3px solid transparent',
                    _hover: {
                        _notDisabled: {
                            borderBottomColor: '[currentColor]',
                        },
                    },
                    _selected: {
                        borderBottomColor: '[currentColor]',
                    },
                },
            },
            vertical: {
                root: {
                    gridTemplateColumns: 'auto 1fr',
                },
                tabList: {
                    flexDirection: 'column',
                },
                tab: {
                    paddingInlineEnd: '[5px]', // to account for border
                    borderInlineEnd: '3px solid transparent',
                    _hover: {
                        _notDisabled: {
                            borderInlineEndColor: '[currentColor]',
                        },
                    },
                    _selected: {
                        borderInlineEndColor: '[currentColor]',
                    },
                },
            },
        },
    },
});

type TabsRecipeProps = Exclude<RecipeVariantProps<typeof tabsRecipe>, undefined>;

export { tabsRecipe, TabsRecipeProps as default };
export type { TabsRecipeProps };
